import { render, staticRenderFns } from "./Step2Cropper.vue?vue&type=template&id=54f6687e&scoped=true"
import script from "./Step2Cropper.vue?vue&type=script&lang=js"
export * from "./Step2Cropper.vue?vue&type=script&lang=js"
import style0 from "./Step2Cropper.vue?vue&type=style&index=0&id=54f6687e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f6687e",
  null
  
)

export default component.exports